<template>
  <div>
    <vab-query-form style="padding-top: 20px">
      <vab-query-form-left-panel :span="12">
        <el-button :icon="Plus" type="primary" @click="handleEdit()">添加</el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="身份" prop="identity">
            <el-select v-model="queryForm.identity" clearable placeholder="请选择身份">
              <el-option v-for="item in identityOptions" :key="item.value" v-bind="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="渠道名称">
            <el-input v-model="queryForm.channelName" clearable placeholder="请输入渠道名称" />
          </el-form-item>
          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list">
      <el-table-column label="渠道名称" prop="channelName" show-overflow-tooltip />
      <el-table-column label="渠道备注" prop="remarks" show-overflow-tooltip />
      <el-table-column label="身份" prop="identityName" />
      <el-table-column label="报名人数" prop="registerNum" />
      <el-table-column label="已审核人数" prop="attendNum" />
      <el-table-column v-if="type == 'EXHIBITION'" label="签到人数" prop="signNum" />
      <!-- <el-table-column label="渠道唯一标识" prop="channelNo" show-overflow-tooltip />
      <el-table-column label="渠道二维码" prop="channelQrcodeUrl" show-overflow-tooltip>
        <template #default="{ row }">
          <el-image fit="cover" :src="row.channelQrcodeUrl" style="width: 100px; height: 100px" />
        </template>
</el-table-column>

<el-table-column label="渠道链接" prop="channelUrl" show-overflow-tooltip /> -->
      <el-table-column label="操作" show-overflow-tooltip width="420">
        <template #default="{ row }">
          <el-row>
            <el-button type="primary" @click="handleEdit(row)">
              <vab-icon icon="edit-2-line" />
              编辑
            </el-button>
            <el-button type="primary" @click="handlePreview(row)">注册渠道码</el-button>
            <el-button v-if="queryForm.meetingType === 'EXHIBITION'" type="primary" @click="handlePreview(row, 'HOME')">
              首页渠道码
            </el-button>
            <el-button type="primary" @click="bindUser(row)">绑定账号</el-button>
          </el-row>
          <el-row style="margin-top: 10px">
            <el-button type="success" @click="seeDetail(row, $event)">查看数据</el-button>
            <el-button type="success" @click="visitorImport(row, $event)">用户导入</el-button>

            <el-button v-if="hostFlag == 'HOST'" type="success" @click="visitorExport(row, $event)">数据导出</el-button>
            <el-button type="success" @click="exportResult(row, $event)">导入结果</el-button>
          </el-row>
          <el-row style="margin-top: 10px">
            <el-button v-if="!isJBH" type="success" @click="visitorNotRealImport(row, $event)">
              非大陆用户导入
            </el-button>
            <el-button type="primary" @click="handleChannelPoster(row, queryForm.meetingType === 'EXHIBITION')">
              渠道海报
            </el-button>
          </el-row>
          <!-- <el-button type="danger" @click="handleDelete(row)">
            <vab-icon icon="delete-bin-6-line" />
            删除
          </el-button> -->
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination background :current-page="queryForm.pageNumber" :layout="layout" :page-size="queryForm.pageSize"
      :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange" />

    <edit ref="editRef" :event-id="queryForm.meetingCode" :identity-options="identityOptions" :meet-type="type"
      @fetch-data="fetchData" />

    <upload-file ref="upLoadRef" :identity-options="identityOptions" :is-j-b-h="isJBH" />

    <upload-result ref="resultRef" />
    <generateWxVue ref="generateWxRef" />
    <export-register ref="exportRegisterRef" />

    <channelDetail ref="channelDetailRef" :identity-options="identityOptions" />

    <ChannelPoster ref="channelPosterRef" />
  </div>
</template>

<script>
import { defineComponent, defineAsyncComponent, getCurrentInstance, reactive, toRefs, onActivated, watch, onMounted } from 'vue'

import qs from 'qs'

import { Delete, Plus, Search } from '@element-plus/icons'
import { getChannelList, _exportUserInfo } from '@/api/channel'

import { exhibitionQueryPermissions, getIdentityOptions } from '@/api/exhibitionManage'
import handleClipboard from '@/utils/clipboard'
import generateWxVue from '@/components/generateWx/generateWx.vue'
import exportRegister from './components/exportRegister.vue'
import channelDetail from './components/channelDetail.vue'
import { createQrcode, shotPro } from '@/api/tool'
import ChannelPoster from './components/ChannelPoster.vue'

import { baseH5URL } from '@/config'

export default defineComponent({
  name: 'ChannelManagar',
  components: {
    Edit: defineAsyncComponent(() => import('./components/channelEdit')),
    uploadFile: defineAsyncComponent(() => import('./components/visitorImport')),
    uploadResult: defineAsyncComponent(() => import('./components/uploadResult')),
    generateWxVue,
    exportRegister,
    channelDetail,
    ChannelPoster,
  },
  setup() {
    const { proxy } = getCurrentInstance()

    const state = reactive({
      queryForm: {
        identity: '',
        channelName: '',
        meetingCode: '',
        meetingType: '',
        pageNum: 1,
        pageSize: 999,
      },
      type: proxy.$route.query.type,
      total: 0,
      shopList: [],
      listLoading: false,
      list: [],
      layout: 'prev, pager, next',
      editRef: null,
      upLoadRef: null,
      resultRef: null,
      generateWxRef: null,
      exportRegisterRef: null,
      channelDetailRef: null,
      channelPosterRef: null,
      appKey: '',
      typeOptions: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '申请会议',
          value: 'HOLD_MEETING',
        },
        {
          label: '申请展览',
          value: 'EXHIBITION',
        },
      ],
      hostFlag: 'HOST',
      identityOptions: [],
      isJBH: (JSON.parse(localStorage.getItem('customInfo')) || {})?.tenantKey === 'J80A84ZBBA40PW1',
    })

    onMounted(() => {
      const info = JSON.parse(localStorage.getItem('customInfo') || '{}')
      if (info.wcs?.[0]?.appKey)
        state.appKey = info.wcs[0].appKey;
    })

    const queryIdentityOptions = () => {
      getIdentityOptions(proxy.$route.query.meetingCode).then((res) => {
        state.identityOptions = res.data.map((item) => ({
          value: item.identity || item.identityType,
          label: item.name || item.identityName,
        }))
      })
    }

    const handleEdit = (row) => {
      if (row?.eventId) {
        state.editRef.showEdit(row)
      } else {
        state['editRef'].showEdit()
      }
    }

    const handleDelete = (row) => {
      if (row.id) {
        proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
          const { msg } = await delCoupon(row.id)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          await fetchData()
        })
      }
    }

    function extractQrParams({ channelNo, identity }, type = 'REGISTER') {
      console.log('identity', identity)

      let ext = {}
      let scenesType = 'REGISTER_CHANNEL_QRCODE'

      if (type === 'HOME' || type.includes('_HOME')) {
        scenesType = 'SUPPER_SCENES_TYPE'
        ext = { channelType: 'EXHIBITIONHOME' }
      }

      const { logo, navTitle, pageId, meetingCode, meetingType } = state.queryForm

      return {
        r: 0,
        b: 0,
        g: 0,
        logo,
        env: '',
        scenesType,
        width: 1280,
        jumpType: '',
        jumpPath: '',
        autoColor: false,
        path: 'pages/index/index',
        params: JSON.stringify({ pageId, navTitle, channelNo, identity, meetingCode, meetingType, ...ext }),
      }
    }

    async function handleChannelPoster(row, isExhibition = false) {
      const { navTitle, meetingCode, meetingType } = state.queryForm

      state.channelPosterRef.open({
        isExhibition,
        channelNo: row.channelNo,
        title: `${navTitle}_${row.channelName}`,
        loadImage: async (type = 'REGISTER') => {
          const params = extractQrParams(row, type)
          const qrCodeUrl = await createQrcode(params).then((res) => res.data.value)
          const query = {
            meetingCode,
            meetingName: navTitle,
            relationType: meetingType,
            qrCodeUrl: encodeURIComponent(qrCodeUrl),
          }
          const shotLink = `${baseH5URL}/batchInvitePoster?${qs.stringify(query)}`
          return shotPro({
            url: shotLink,
            selector: '.box',
          }).then((res) => res.data)
        },
      })
    }

    const handlePreview = (row, type = 'REGISTER') => {
      const params = extractQrParams(row, type)
      //  2026黄跨会 - Yandex Market 2026全国巡回峰会青岛站 定制逻辑
      if (row.meetingCode === "MT2062378582679826432") {
        params.logo = 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/wemeet/20260604/20260604175447_226_62.png'
      }
      state.generateWxRef.handleOpen(row, params)
    }

    const queryData = () => {
      fetchData()
    }

    const copy = (row, event) => {
      handleClipboard(row.channelUrl, event)
    }

    const fetchData = async () => {
      state.listLoading = true
      const { data } = await getChannelList(state.queryForm)
      state.list = (data && data.data) || []
      state.total = (data && data.total) || 0
      state.listLoading = false
    }

    const handleSizeChange = (val) => {
      state.queryForm.pageSize = val
      queryData()
    }
    const handleCurrentChange = (val) => {
      state.queryForm.pageNum = val
      queryData()
    }
    watch(
      () => proxy.$route.query,
      async (newVal, oldVal) => {
        console.log(newVal, oldVal, '===1222222')
        state.type = proxy.$route.query.type || 'EXHIBITION'
      }
    )

    onActivated(() => {
      console.log(proxy.$route)
      state.queryForm.meetingCode = proxy.$route.query.meetingCode
      state.queryForm.navTitle = proxy.$route.query.navTitle
      state.queryForm.pageId = proxy.$route.query.pageId
      state.queryForm.logo = proxy.$route.query.logo
      state.queryForm.meetingType = proxy.$route.query.type != 'HOLD_MEETING' ? 'EXHIBITION' : proxy.$route.query.type
      state.type = proxy.$route.query.type != 'HOLD_MEETING' ? 'EXHIBITION' : proxy.$route.query.type
      queryData()
      getPermissionCustomized({ code: state.queryForm.meetingCode })
      queryIdentityOptions()
    })

    // 观众根据渠道导入
    const visitorImport = (row) => {
      // console.log(row)
      console.log(state.appKey, row)
      let obj = {
        appKey: state.appKey || row.appKey,
        channelName: row.channelName,
        channelNo: row.channelNo,
        channelQrcodeUrl: row.channelQrcodeUrl,
        channelUrl: row.channelUrl,
        delFlag: row.delFlag,
        eventId: row.eventId,
        id: row.id,
        meetingCode: row.meetingCode,
        remarks: row.remarks,
        meetingType: row.type,
      }
      state.upLoadRef.showEdit(obj)
    }
    const visitorNotRealImport = (row) => {
      console.log(row)
      let obj = {
        appKey: state.appKey || row.appKey,
        channelName: row.channelName,
        channelNo: row.channelNo,
        channelQrcodeUrl: row.channelQrcodeUrl,
        channelUrl: row.channelUrl,
        delFlag: row.delFlag,
        eventId: row.eventId,
        id: row.id,
        meetingCode: row.meetingCode,
        remarks: row.remarks,
        meetingType: row.type,
        notReal: true,
      }
      state.upLoadRef.showEdit(obj)
    }

    // 查询导出结果
    const exportResult = (row) => {
      console.log(state.resultRef, row)
      state.resultRef.showEdit(row)
    }

    // 查看数据
    const seeDetail = (row) => {
      state.channelDetailRef.handleOpen(row, state.type, state.queryForm.meetingCode)
    }

    const visitorExport = (row) => {
      console.log(row)
      const params = {
        code: state.queryForm.meetingCode,
        channelNo: row.channelNo,
        relationType: state.type,
      }
      state.exportRegisterRef.handleOpen(params, `主办渠道`, `MEETING_CHANNEL_REGISTER_REPORT`)
      // _exportUserInfo(params).then((res) => {
      //   console.log(res)
      //   if (!res.data.success) {
      //     proxy.$baseMessage(
      //       `当前数据为空，无法导出`,
      //       'error',
      //       'vab-hey-message-error'
      //     )
      //   } else {
      //     window.open(res.data.fileUrl)
      //   }
      // })
    }

    const bindUser = (row) => {
      proxy.$router.push({
        path: '/exhibitionManage/bindChannelAccount',
        query: { channelId: row.id },
      })
    }

    const getPermissionCustomized = async (row) => {
      const { data } = await exhibitionQueryPermissions({
        meetingCode: row.code,
        meetingType: state.queryForm.meetingType,
      })

      state.hostFlag = data
    }

    return {
      ...toRefs(state),
      handleEdit,
      queryData,
      fetchData,
      handleSizeChange,
      handleCurrentChange,
      handleDelete,
      copy,
      visitorImport,
      visitorExport,
      exportResult,
      visitorNotRealImport,
      Delete,
      Search,
      Plus,
      handlePreview,
      bindUser,
      seeDetail,
      getPermissionCustomized,
      handleChannelPoster,
    }
  },
})
</script>

<style lang="scss" scoped></style>
